import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, Validators,FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
} from "@cvx/nextpage";
import { MAWPComponent } from '../../mawp/mawp.component';
import { MAEPComponent } from '../../maep/maep.component';
import { Subject } from "rxjs";
import { LTA_module } from "../../../services/lta_module";
import { Form1 } from "../../../services/form1";
import { Level1Data } from "../../../services/level1Data";
import { MatStepper } from "@angular/material/stepper";
import { FormControlsEventProxyService } from "../../../services/formcontrols_eventproxy_service";
import { MatRadioChange } from "@angular/material/radio";
import { MatDialog } from "@angular/material/dialog";
import { VerticalvesselComponent } from "../../type-a-component/verticalvessel/verticalvessel.component";
import { HorizontalvesselComponent } from "../../type-a-component/horizontalvessel/horizontalvessel.component";
import { CarbonsteelandlowalloysteelComponent } from "../../type-a-component/carbonsteelandlowalloysteel/carbonsteelandlowalloysteel.component";
import { HighalloyandnonferroussteelComponent } from "../../type-a-component/highalloyandnonferroussteel/highalloyandnonferroussteel.component";
import { Overlay } from "@angular/cdk/overlay";
import { WarningModalComponent } from "../../warning-modal/warning-modal.component";
import { ComponentEventService } from "projects/fitnessforservice/src/services/component_event.service";
import { Component_MAWP } from "projects/fitnessforservice/src/services/component_mawp";
import { Component_MAEP } from "projects/fitnessforservice/src/services/component_maep";


@Component({
    selector: "local-metal-loss",
    templateUrl: "local-metal-loss.component.html",
    standalone: false
})
export class LocalMetalLossComponent implements OnInit {
  localmetalloss_formGroup: FormGroup;
  @ViewChild("stepper") private myStepper: MatStepper;
  @ViewChild('mawpComponent') mawpComponent!: MAWPComponent;
  @ViewChild('maepComponent') maepComponent!: MAEPComponent;
  totalStepsCount: number;

  inspectionDataCalculate: Subject<boolean> = new Subject();
  public level1Data = Level1Data;

  applicability: string;
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  path: string;
  reevaluSub: any;  
  //Shameer 
 //typeA : number;
  isreevalu = true;
  tooltipText1: string = '';
  tooltipText2: string = '';
  tooltipText3: string = '';
  tooltipText4: string = ''; 
  intUnittype:number;

  validationList = [];
  summary: string;
  inspectionDataResult: string;
  result: string;
  SelectedValue: string;
  isCheckboxDisabled = false;
  isCylAtmradio = true; // always disabled this radio button for the current requirement
  showDIRequiredMessage: boolean = false;

  firstFormGroup = this._formBuilder.group({
    applicabilityCheckbox: ["", Validators.requiredTrue],
    typeACheckbox:["",Validators.required],
    radio:["",],
  });
  secondFormGroup = this._formBuilder.group({});
  isLinear = true;

  constructor(
    private NP: NextPageService,
    private activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private formControlsEventProxyService: FormControlsEventProxyService,
    public dialog: MatDialog,
     private componentService: ComponentEventService
  ) {
    this.path = activatedRoute.snapshot["_routerState"].url;

    this.LTA_Assesment_Setup();
    this.localmetalloss_formGroup = this._formBuilder.group({
      radioButton_DI: ["", Validators.required]
    });
     //shameer   
     this.firstFormGroup.get('typeACheckbox').disable();
     this.firstFormGroup.get('applicabilityCheckbox').disable();
  }

  goToComponent() {

    if(((this.firstFormGroup.get('radio').value) != null) &&
        ((this.firstFormGroup.get('applicabilityCheckbox').enabled == true ) ||
        (this.firstFormGroup.get('typeACheckbox').enabled == true))
      )
    {
    this.firstFormGroup.controls["applicabilityCheckbox"].markAsDirty({
      onlySelf: true,
    });
    this.firstFormGroup.controls["applicabilityCheckbox"].markAsTouched({
      onlySelf: true,
    });

    //shameer
    let typAcheckbox1 = this.firstFormGroup.controls["typeACheckbox"];
    typAcheckbox1.markAsDirty({
      onlySelf: true,
    });
    typAcheckbox1.markAsTouched({
      onlySelf: true,
    });

    this.goNextStep();
  }else{
    this.dialog.open(WarningModalComponent, {
      width: "450px",
      data: {
        warningMessage: [
          "Select an Option to Proceed!..Please.",
        ],
        caption: "FFS: Applicability and Limitations",
        captionCenter: true,
        cancelButtonShow: false,
      },
    });
  }
  }

  onNextClickcalculateSummary() {
    const selected = this.localmetalloss_formGroup.get('radioButton_DI')?.value;
    if (selected.toString().toUpperCase() === 'radioButton1_DI_enabled'.toString().toUpperCase()) {
      this.mawpComponent?.calculateSummary();
    } else if (selected.toString().toUpperCase() === 'radioButton2_DI_enabled'.toString().toUpperCase()) {
      this.maepComponent?.calculateSummary();
    } else {
      console.warn('Please select a pressure type.');
    }
  }
  
  getApplicabilityCheckbox_formControl(): FormControl {
    return this.firstFormGroup.get("applicabilityCheckbox") as FormControl;
  }
  gettypeAcheckbox_formControl():FormControl {
    return this.firstFormGroup.get("typeACheckbox") as FormControl;
  }

  get isSphericalSelected(): boolean {
    return Number(this.firstFormGroup.get('radio')?.value) === 5;
  }

  ngOnInit(): void {
    this.summary = "";
    this.result = "";
    this.applicability = `  
      <ol>  
        <li>The original design criteria were in accordance with a recognized code or standard.</li>  
        <li>The component is not operating in the creep range. See the Help Menu for temperature limit used to define the creep range.</li>
        <li>The material is considered to have sufficient material toughness and the component is not subject to embrittlement during operation due to temperature and/or process environment.</li>  
        <li>The component is not in cyclic service (i.e., less than 150 cycles in past and future planned operation or satisfying the cyclic service screening criteria).</li>  
        <li>Type A components subject to internal pressure or external pressure. Type A components have a design equation that specifically relates pressure and/or other loads to a required wall thickness. Examples are:  
          <ol type="a">  
            <li>Pressure vessel cylindrical and conical shell sections satisfying the dimensions criteria</li>  
            <li>Spherical pressure vessels and storage spheres</li>  
            <li>Spherical, elliptical and torispherical formed heads</li>  
            <li>Straight sections of piping systems and elbows or pipe bends that do not have structural attachments satisfying the size and temperature criteria</li>  
            <li>Cylindrical atmospheric storage tank shell courses</li>  
          </ol>  
        </li>  
      </ol>  
    `;
    localStorage.setItem('calculationStep', '0'); //this is zero step (Applicability)

    this.formControlsEventProxyService.getLTA_ApplicabilityEventSubject().subscribe((v) => {
      this.updateApplicabilityCheckboxToChecked();
      this.firstFormGroup.get('applicabilityCheckbox').enable();
    });
     // shameer- start
     this.formControlsEventProxyService
     .getltatypeAApplicabilitySubject()
     .subscribe((v) => {
       this.updatetypeACheckboxToChecked();
       this.firstFormGroup.get('typeACheckbox').enable();
       
     });

     this.formControlsEventProxyService
     .getltatypeAupdateradioSubject()
     .subscribe((v) => {
       this.updateradiobuttonafterimport();
       this.updatetooltip();
     });
     // shameer -end
      this.reevaluSub = this.componentService.reevaluButtonEnabled.subscribe(
      enabled => this.isreevalu = !enabled
    );
    this.componentService.typeDamageSelected$.subscribe(val => {
      this.localmetalloss_formGroup.get('radioButton_DI').patchValue(val);
    });
  }

  goToMAWPComponent() {
      const diVal = this.localmetalloss_formGroup.get('radioButton_DI')?.value;
      this.validationList = [];
      if (!diVal) {
        this.showDIRequiredMessage = true;
        this.localmetalloss_formGroup.get('radioButton_DI')?.markAsTouched();
        this.localmetalloss_formGroup.get('radioButton_DI')?.markAsDirty();
        return; // stay on Applied Load step
      }
      this.showDIRequiredMessage = false;
      const resultFromValidation: boolean = Component_MAWP.check_LocalMetalLoss_TypeOfData(
        this.localmetalloss_formGroup
      );
      this.validationList = Component_MAWP.validationMessageTypeOfData;
      if (!resultFromValidation) return;
      this.goNextStep();
  }

  goToMAEPComponent() {
      const diVal = this.localmetalloss_formGroup.get('radioButton_DI')?.value;
      this.validationList = [];
      if (!diVal) {
        this.showDIRequiredMessage = true;
        this.localmetalloss_formGroup.get('radioButton_DI')?.markAsTouched();
        this.localmetalloss_formGroup.get('radioButton_DI')?.markAsDirty();
        return; // stay on Applied Load step
      }
      this.showDIRequiredMessage = false;
      const resultFromValidation: boolean = Component_MAEP.check_LocalMetalLoss_TypeOfData(
        this.localmetalloss_formGroup
      );
      this.validationList = Component_MAEP.validationMessageTypeOfData;
      if (!resultFromValidation) return;
      this.goNextStep();
  }

  updateradiobuttonafterimport()
  {
    
    this.firstFormGroup.get('radio').patchValue(this.componentService.typearadioselectedValue.toString());
  
  }
  updatedamageafterimport() {
      // After importing and updating the service value
    this.localmetalloss_formGroup.get('radioButton_DI')
    .patchValue(this.componentService.typeDamageSelectedValue);
  }

  updatetooltip()
  {
   // this.tooltipText1 = this.componentService.typeatypeAinput1val.toString();

    const a1 = this.componentService.typeatypeAinput1val.toString();
    const a2 = this.componentService.typeatypeAinput2val.toString()

    const ut = this.componentService.typeAUnitTypeval.toString();
    const typaPF = this.componentService.typeAresultjsnval.toString();
    
    const Passres = "\n\nThe component meets the Type A screeing criteria";
    const Failres = "\n\nThe component doesn't meet the Type A screeing criteria.";    

    if(this.componentService.typearadioselectedValue.toString()== "1")
    {
      if (ut == "0")
      {
        const l1 = "Vertical Location of the Flaw, H (inch)";
        const l2 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch)";
      
        if(typaPF == "0")
        {
          this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
        }else if(typaPF == "1")
        {
          this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
        }
        
      }
      else if( ut == "1")
      {
        const l1 = "Vertical Location of the Flaw, H*  (mm) *";
        const l2 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
       
        if(typaPF == "0")
          {
            this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
      }

      this.tooltipText2 ="";
      this.tooltipText3 ="";
      this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "2")
    {
      if (ut == "0")
        {
          const l1 = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (inch) *";
          const l2 = "\nDistance between saddle supports Lss  (inch) *";
          
        if(typaPF == "0")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
         
        }
        else if( ut == "1")
        {
          const l1 = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
          const l2 = "\nDistance between saddle supports Lss  (mm) *";
          
        if(typaPF == "0")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }

        this.tooltipText1 ="";
        this.tooltipText3 ="";
        this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "3")
    {
      if (ut == "0")
        {
          const l1 = "Maximum Operating Temperature, Top  (℉)";
          const l2 = "\nPipe Nominal size, NPS  (inch)";
         
        if(typaPF == "0")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }
        else if( ut == "1")
        {
          const l1 = "Maximum Operating Temperature, Top  (℃)";
          const l2 = "\nPipe Nominal size, NPS  (mm)";
          
        if(typaPF == "0")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }
        this.tooltipText1 ="";
        this.tooltipText2 ="";
        this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "4")
    {
        if (ut == "0")
          {
            const l1 = "Maximum Operating Temperature, Top  (℉)";
            const l2 = "\nPipe Nominal size, NPS  (inch)";
           
        if(typaPF == "0")
          {
            this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
          }
          else if( ut == "1")
          {
            const l1 = "Maximum Operating Temperature, Top  (℃)";
            const l2 = "\nPipe Nominal size, NPS  (mm)";
           
            if(typaPF == "0")
              {
                this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
              }else if(typaPF == "1")
              {
                this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
              }
          }
          this.tooltipText1 ="";
          this.tooltipText2 ="";
          this.tooltipText3 ="";
     }
      else if (this.componentService.typearadioselectedValue.toString()== "5")
      {
          if (ut == "0")
            {
              
            }
            else if( ut == "1")
            {
              
            }
            this.tooltipText1 ="";
            this.tooltipText2 ="";
            this.tooltipText3 ="";
            this.tooltipText4 ="";
      }
      
  }

  updateApplicabilityCheckboxToChecked() {
    let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    applicabilityCheckbox.setValue(true);
  }
  //shameer
  updateApplicabilityCheckboxToUnChecked() {
    let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    applicabilityCheckbox.setValue(false);
  }

  goNextStep() {
    let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    let typeACheckbox = this.gettypeAcheckbox_formControl();
    if ((applicabilityCheckbox.value === true)||(typeACheckbox.value === true))
      localStorage.setItem('calculationStep', (this.myStepper.selectedIndex + 1).toString());

    this.myStepper.next();
  }

  goPreviousStep() {
    localStorage.setItem('calculationStep', (this.myStepper.selectedIndex - 1).toString());
    this.myStepper.previous();
  }

  LTA_Assesment_Setup() {
    Component_MAWP.MAWP_initialize();
    LTA_module.LTA_initialize();

    Component_MAWP.strD_class = "LTA";
    Component_MAWP.strD_iclass = 1;
    Component_MAWP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
    Form1.prev_strD_class = "LTA";
    
    Component_MAEP.MAEP_initialize();
    Component_MAEP.strD_class = "LTA";
    Component_MAEP.strD_iclass = 1;
    Component_MAEP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
    Form1.prev_strD_class = "LTA";
  }

  handleSummaryData(data: any) {
    this.summary = data;
  }

  handleInspectionData(data: any) {
    this.inspectionDataResult = data;
  }

  calculateResult(): void {
    this.inspectionDataCalculate.next(true);
  }
  onRadioChange(event:MatRadioChange)
  {
    if(event.value ==1)
    {
      const dialogRef = this.dialog.open(VerticalvesselComponent,{height : '725px' ,width :'1200px', disableClose :true })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Data from dialog:', result.data1,result.data2); 
        if (result.cancel) {

          this.updateTypeAradioToUncheck();
          this.updateApplicabilityCheckboxToUnChecked();
          this.updatetypeACheckboxToUnChecked();
          this.firstFormGroup.get('applicabilityCheckbox').disable();
          this.firstFormGroup.get('typeACheckbox').disable();
          //clear all tool tips
          this.tooltipText1="";
          this.tooltipText2="";
          this.tooltipText3="";
          this.tooltipText4=""; 

        } else {
          console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
          if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
            {
                this.updateApplicabilityCheckboxToUnChecked();
                this.firstFormGroup.get('applicabilityCheckbox').disable();
                this.updatetypeACheckboxToUnChecked();
                this.firstFormGroup.get('typeACheckbox').enable();

                //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");

                //for enabling Reeval button
                this.isreevalu = false;
                //for removing tool tips of horizontal /carbon/highalloy  tooltip
                this.tooltipText2="";
                this.tooltipText3="";
                this.tooltipText4="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('verticalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;
                
               this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;

              }
            
            }
            else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
              {
                this.updateApplicabilityCheckboxToUnChecked();
                this.firstFormGroup.get('applicabilityCheckbox').enable();
                this.updatetypeACheckboxToUnChecked();
                this.firstFormGroup.get('typeACheckbox').disable();

                //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");

                //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of horizontal /carbon/highalloy  tooltip
                this.tooltipText2="";
                this.tooltipText3="";
                this.tooltipText4="";

                //for tooltip on vessels
                const userinputs = localStorage.getItem('verticalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
                const res = "\n\nThe component meets the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
                const res = "\n\nThe component meets the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;

              }

              }
        }
     
      }
    });   
      //localStorage.setItem("TypeAselection","1"); // as we selected HighAlloy
      this.componentService.updateTypeASelectedValue(1); // as we selected vertical
    }
    else if(event.value==2)
    {
      const dialogRef = this.dialog.open(HorizontalvesselComponent,{height : '650px' ,width :'1200px',disableClose :true})
     
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();
             //clear all tool tips
             this.tooltipText1="";
             this.tooltipText2="";
             this.tooltipText3="";
             this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();

                  //for enabling Reeval button
                this.isreevalu = false;
                //for removing tool tips of vertical/carbon/highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText3="";
                this.tooltipText4="";
               


                 //for tooltip on vessels
                 const userinputs = localStorage.getItem('horizontalinputs');
                 const Input_data = userinputs ? JSON.parse(userinputs) : null;
                 const a1 = Input_data.inputvalue1;
                 const a2 = Input_data.inputvalue2;

                 this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
                const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText2 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
                const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText2 = lbl1+a1+lbl2+a2+res;

              }
                          

                  //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                    //for enabling Reeval button
                this.isreevalu = false;
                //for removing vertical/carbon/highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText3="";
                this.tooltipText4="";

                //for tooltip on vessels
                const userinputs = localStorage.getItem('horizontalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
                 const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText2 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
                 const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText2 = lbl1+a1+lbl2+a2+res;
 
               }

                  //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      //localStorage.setItem("TypeAselection","2"); // as we selected Horizontal
      this.componentService.updateTypeASelectedValue(2); // as we selected Horizontal
      localStorage.setItem("TypeAradioselection","2"); 
    }
    else if(event.value==3)
    {
      const dialogRef = this.dialog.open(CarbonsteelandlowalloysteelComponent,{height : '520px' ,width :'1200px',disableClose :true})
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

              //clear all tool tips
              this.tooltipText1="";
              this.tooltipText2="";
              this.tooltipText3="";
              this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();

                    //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of vertical/horizontal /highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText2="";
                this.tooltipText4="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('carbonsteelinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText3 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText3 = lbl1+a1+lbl2+a2+res;
 
               }


                  //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                   //for enabling Reeval button
                   this.isreevalu = false;

                    //for removing tool tips of vertical/horizontal /highalloy  tooltip
                    this.tooltipText1="";
                    this.tooltipText2="";
                    this.tooltipText4="";
    
    
                    //for tooltip on vessels
                    const userinputs = localStorage.getItem('carbonsteelinputs');
                    const Input_data = userinputs ? JSON.parse(userinputs) : null;
                    const a1 = Input_data.inputvalue1;
                    const a2 = Input_data.inputvalue2;

                    this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                   if(this.intUnittype==0) //us customary
                  {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                    const res = "\n\nThe component meets the Type A screeing criteria."
                    this.tooltipText3 = lbl1+a1+lbl2+a2+res;
                  }
                  else if(this.intUnittype == 1) //si units
                  {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                    const res = "\n\nThe component meets the Type A screeing criteria."
                    this.tooltipText3 = lbl1+a1+lbl2+a2+res;
    
                  }

                  //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      //localStorage.setItem("TypeAselection","3"); // as we selected carbon and low alloy
      this.componentService.updateTypeASelectedValue(3); // as we selected carbon and low alloy
      localStorage.setItem("TypeAradioselection","3"); 
    }
    else if(event.value==4)
    {
       const dialogRef = this.dialog.open(HighalloyandnonferroussteelComponent,{height : '520px' ,width :'1200px', disableClose :true})
       dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

            //clear all tool tips
            this.tooltipText1="";
            this.tooltipText2="";
            this.tooltipText3="";
            this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();

                  
                  //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of vertical/horizontal /carbon tooltip
                this.tooltipText1="";
                this.tooltipText2="";
                this.tooltipText3="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('highalloyinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
 
               }


                  //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                  
                  //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of vertical/horizontal /carbon tooltip
                this.tooltipText1="";
                this.tooltipText2="";
                this.tooltipText3="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('highalloyinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
 
               }
                  //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                
                }
          }
       
        }
      });
      //localStorage.setItem("TypeAselection","4"); // as we selected HighAlloy
      this.componentService.updateTypeASelectedValue(4);// as we selected HighAlloy
      localStorage.setItem("TypeAradioselection","4"); 

    }
    else
    {  
      if(event.value==5)  // when 2nd radio button is selected , consider typeA as passed
      {
          //for enabling Reeval button
          this.isreevalu = false;

          //clear all tool tips
          this.tooltipText1="";
          this.tooltipText2="";
          this.tooltipText3="";
          this.tooltipText4="";

         //for typea result in report generation
         localStorage.setItem("TypeAPassorFail","1");

        // Spherical components support only Internal Pressure.
        this.onChangeRadioButton1_DI('radioButton1_DI_enabled');
      }

      // when we select 5 or 6 or 7 radio buttons
       this.updateApplicabilityCheckboxToUnChecked();
       this.firstFormGroup.get('applicabilityCheckbox').enable();
       this.updatetypeACheckboxToUnChecked();
       this.firstFormGroup.get('typeACheckbox').disable();
       //localStorage.setItem("TypeAselection","5"); // as we selected Spherical components
       this.componentService.updateTypeASelectedValue(5); // as we selected Spherical components

       localStorage.setItem("TypeAradioselection","5"); 
    }
   
  }
  

  updateTypeAradioToUncheck()
  {
    this.firstFormGroup.get('radio').patchValue(null);    
  }

  gettypeAradio_formControl(): FormControl {
    return this.firstFormGroup.get("radio") as FormControl;
  }

  updatetypeACheckboxToChecked(){
    let typeAcheckbox = this.gettypeACheckbox_formControl();
    typeAcheckbox.setValue(true);
  }

  updatetypeACheckboxToUnChecked(){
    let typeAcheckbox = this.gettypeACheckbox_formControl();
    typeAcheckbox.setValue(false);
  }
  gettypeACheckbox_formControl(): FormControl {
    return this.firstFormGroup.get("typeACheckbox") as FormControl;
  }

  typeareevaluate()
  {
    this.updateTypeAradioToUncheck();
    this.updateApplicabilityCheckboxToUnChecked();
    this.updatetypeACheckboxToUnChecked();
    this.firstFormGroup.get('applicabilityCheckbox').disable();
    this.firstFormGroup.get('typeACheckbox').disable();
    
    //for disbling Reeval button
    this.isreevalu = true;
    this.tooltipText1="";
    this.tooltipText2="";
    this.tooltipText3="";
    this.tooltipText4="";
    localStorage.removeItem('verticalinputs');
  }

  onChangeRadioButton1_DI(value: string) {
     const previousValue = this.componentService.radioButtonDI;
      // Save the value in your form if needed
      this.localmetalloss_formGroup.get('radioButton_DI').setValue(value);
      this.showDIRequiredMessage = false;

      // When switching Internal/External, force component-type dropdowns back to Select Type.
      if (previousValue && previousValue !== value) {
        Component_MAWP.intEquip = -1;
        Component_MAEP.intEquip = -1;
        this.componentService.updateCompMAWPintEquip(-1);
        this.componentService.updateCompMAEPintEquip(-1);
      }

      // Set LML_module.intLoadingType based on selection
      if (value.toString().toUpperCase() === 'RADIOBUTTON1_DI_ENABLED') {
          LTA_module.intLoadingType = 0; // Internal Pressure
          // Store radio button value in both components
           Component_MAWP.strRadio = 0;
           Component_MAEP.strRadio = 0;
           Component_MAWP.strD_class = "LTA";
          Component_MAWP.strD_iclass = 1;
          Component_MAWP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
          Form1.prev_strD_class = "LTA";
      } else if (value.toString().toUpperCase() === 'RADIOBUTTON2_DI_ENABLED') {
          LTA_module.intLoadingType = 1; // External Pressure
          // // Store radio button value in both components
          Component_MAWP.strRadio = 1;
          Component_MAEP.strRadio = 1;
          Component_MAEP.strD_class = "LTA";
          Component_MAEP.strD_iclass = 1;
          Component_MAEP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
          Form1.prev_strD_class = "LTA";
      }
       //Store in service instead of localStorage
       this.componentService.radioButtonDI = value;
    }
}
